module.exports = __webpack_public_path__ + "img/showcase-messaging.aad8dc95.png";